import { ThemeSchema } from "../theme";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const favIcons = [
  {
    id: "fave-icon",
    src: "/favicon/paythem-favicon.icon",
  },
  {
    id: "fave-icon-32x32",
    src: "/favicon/paythem-favicon-32x32.png",
  },
  {
    id: "fave-icon-192x192",
    src: "/favicon/paythem-favicon-192x192.png",
  },
  {
    id: "fave-icon-apple",
    src: "/favicon/paythem-favicon-192x192.png",
  },
];

// eslint-disable-next-line import/prefer-default-export
export const draycirTheme: ThemeSchema = {
  id: "draycir",
  logoMaxWidth: undefined,
  footerLogo: "paythem-footer-draycir.svg",
  spinners: {
    expanding: "draycir-spinner-expand-draycir.json",
    shrinking: "draycir-spinner-shrink-draycir.json",
  },
  favIcons,
};
